import { useState, useRef, useEffect, useCallback } from 'react';

export const useTimer = ({ maxTime }) => {
  const [timer, setTimer] = useState(0);
  let intervalRef = useRef<any>(null);
  const reduceTimer = () => {
    setTimer(prev => {
      if (prev === 0) {
        clearInterval(intervalRef.current);
        return prev;
      } else {
        return prev - 1;
      }
    });
  };
  useEffect(() => {
    return () => clearInterval(intervalRef.current);
  }, []);
  const startTimer = useCallback(() => {
    clearInterval(intervalRef.current);
    setTimer(maxTime);
    intervalRef.current = setInterval(reduceTimer, 1000);
  }, [setTimer, maxTime]);
  return { startTimer, timer };
};

/**
 * Simple function to convert into JavaScript date
 * @param str 'Wed Jul 05 18:58:12 IST 2023'
 * @returns Date
 */
export function getDateFromAPI(str) {
  const exp1 = str.split(' ');
  const jsDateArrangement = `${exp1[0]} ${exp1[1]} ${exp1[2]} ${exp1[5]} ${exp1[3]}`;
  return new Date(jsDateArrangement);
}

export function logger(hideAll = false) {
  return (...args) => {
    if (hideAll) {
      return;
    }
    console.log(...args);
  };
}
interface urlParamsType {
  bureau: string;
  loanType: string;
  loanCategory: string;
  loanAmount: string;
  API_CategoryID: string;
  API_ProductID: string;
  API_SubProductID1: string;
  API_SubProductID2: string;
  editableReferralCode: string;
  showReferral: string;
  referralCode: string;
  requiredId: string;
  newProductType: string;
}
export function getUrlParams(): urlParamsType {
  const url = new URL(window.location.href);

  const inputString = url.search;
  const encryptedQueryString = inputString.startsWith('?')
    ? inputString.slice(1)
    : inputString;
  const queryString = atob(encryptedQueryString);
  const keyValuePairs = queryString.split('&');
  const parsedObject = {
    bureau: '',
    loanType: '',
    loanCategory: '',
    loanAmount: '',
    API_CategoryID: '',
    API_ProductID: '',
    API_SubProductID1: '',
    API_SubProductID2: '',
    editableReferralCode: '',
    showReferral: '',
    referralCode: '',
    requiredId: '',
    newProductType: ''
  };
  keyValuePairs.forEach(pair => {
    const [key, value] = pair.split('=');
    const parsedValue = decodeURIComponent(value);
    parsedObject[key] = parsedValue;
  });
  return parsedObject;
}

// export const urlParams = {
//   bureau: url.searchParams.get('bureau'),
//   loanType: url.searchParams.get('loanType'),
//   loanCategory: url.searchParams.get('loanCategory'),
//   loanAmount: url.searchParams.get('loanAmount'),
//   API_CategoryID: url.searchParams.get('API_CategoryID'),
//   API_ProductID: url.searchParams.get('API_ProductID'),
//   API_SubProductID1: url.searchParams.get('API_SubProductID1'),
//   API_SubProductID2: url.searchParams.get('API_SubProductID2'),
//   editableReferralCode: url.searchParams.get('editableReferralCode'),
//   showReferral: url.searchParams.get('showReferral'),
//   referralCode: url.searchParams.get('referralCode')
// };

export const REFERRAL_CODES = {
  CIBIL_LOS: 'CIBIL-LOS',
  EASY_LOS: 'EASY-LOS',
  // CIBIL_ADV is used for RF advisory
  CIBIL_ADV: 'CIBIL-ADV'
};

export function showUserForm() {
  const queryString = atob(window.location.search.replace('?', ''));
  const params = new URLSearchParams(queryString);
  if (params.has('referralCode')) {
    return true;
  }
  return false;
}

export function showAuthenticationError(error) {
  if (Number(error?.status) === 401) {
    return 'Your session has expired. Please refresh the page to continue.';
  }
}
